import { CardType } from './../type';
import { jumpPage } from '@tencent/wphk-components-jump-page';

/**
 * 映射券类型(子类 映射 大类)
 */
export function mapCouponType(couponType: any): CardType {
  const type = +couponType;
  switch (type) {
    case 1: // 金额优惠
    case 2: // 比例折扣优惠
    case 3: // 变金额优惠
      return CardType.AutoCoupon;
    case 5001:  // 非CDK类商户展示券
    case 5002:  // 普通CDK类商户展示券
    case 5003:  // 单CDK类商户展示券
      return CardType.DisplayCoupon;
  }
  // 默认展示券
  return CardType.DisplayCoupon;
}


/**
 * 跳转券详情
 * 根据券类型处理
 */
export function goCouponDetail(type: CardType | undefined, options: { userScid: string, adtag: string }) {
  if (type === CardType.AutoCoupon) {
    // 优惠券
    jumpPage.goCouponDetail(options);
  }
  if (type === CardType.DisplayCoupon) {
    // 展示券
    jumpPage.goMerchantCouponDetail(options);
  }
  // 其他类型
  console.error(`goCouponDetail type: {${type}} is unexpected. With options: `, options);
}

/**
 * 判断是否为展示券或优惠券，两者的UI/逻辑/交互基本一致的
 */
export function isAutoOrDisplayCoupon(type: CardType | undefined): boolean {
  return type !== undefined && [CardType.AutoCoupon, CardType.DisplayCoupon].includes(type);
}

